import { DownOutlined } from "@ant-design/icons";
import { PENDO_ID, pendoId } from "../../lib/pendoIds";
import styles from "./TokenChip.module.css";

/**
 * A committed token chip inside the search bar. Every click calls `onOpenConfig` -- there is no
 * separate sibling-swap dropdown; the per-type flow diagram showed every token type routing
 * through the same SELECTED+configPanel+ADD-TO-YOUR-SEARCH flow, including "swapping" a value.
 * The token stays clickable/editable for as long as it sits in the bar, not just at the moment
 * it was first committed. `selected`: the token whose config panel is open ("Focused/Selected").
 */
const TokenChip = ({ display, tokenType, selected = false, onOpenConfig }) => {
  const handleActivate = () => onOpenConfig?.();

  return (
    <span
      {...pendoId(PENDO_ID.SEARCH_TOKEN, tokenType)}
      role="button"
      tabIndex={0}
      aria-label={`${display}, edit`}
      onClick={handleActivate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleActivate();
        }
      }}
      className={selected ? `${styles.chip} ${styles.selected}` : styles.chip}
    >
      {display}
      <DownOutlined className={styles.caret} />
    </span>
  );
};

export default TokenChip;
